module.exports = __webpack_public_path__ + "static/group4_4-8646a902ce2b9754647eee728f995489.webp";